import React, { FC } from 'react';

import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogTitle from './DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Divider, useMediaQuery } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import useStyles from './styles';

export interface CustomDialogProps extends Omit<DialogProps, 'title'> {
  title?: string | FC<any> | JSX.Element;
  actions?: React.ComponentElement<any, any>;
  onClose?: () => void;
  loading?: boolean;
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomDialog: FC<CustomDialogProps> = (props) => {
  const { title, loading, actions, onClose, children, ...rest } = props;

  const classes = useStyles();

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      {...rest}
      TransitionComponent={Transition}
      fullScreen={isMobile}
      aria-labelledby="form-dialog-title">
      {loading && <LinearProgress color="secondary" />}

      {(title || onClose) && (
        <>
          <DialogTitle id="form-dialog-title" onClose={onClose}>
            {title}
          </DialogTitle>
          <Divider variant="fullWidth" />
        </>
      )}

      <DialogContent className="grey-scroll-bar">{children}</DialogContent>

      <DialogActions className={classes.actions}>{actions}</DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
